import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["date", "onChange", "onYearChange", "minDate", "maxDate", "disablePast", "disableFuture", "animateYearScrolling"];
import React from 'react';
import PropTypes from 'prop-types';
import DateUtils from '../../utils/date';
import Year from './Year';
import { YearViewContainer } from './styles';
var utils = new DateUtils();
var YearView = function YearView(_ref) {
  var date = _ref.date,
    onChange = _ref.onChange,
    onYearChange = _ref.onYearChange,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    disablePast = _ref.disablePast,
    disableFuture = _ref.disableFuture,
    animateYearScrolling = _ref.animateYearScrolling,
    other = _objectWithoutProperties(_ref, _excluded);
  var selectedYearRef = React.useRef(null);
  React.useEffect(function () {
    if (selectedYearRef.current && selectedYearRef.current.scrollIntoView) {
      selectedYearRef.current.scrollIntoView({
        behavior: animateYearScrolling ? 'smooth' : 'auto'
      });
    }
  }, []);
  var currentYear = utils.getYear(date);
  var onYearSelect = React.useCallback(function (year) {
    var newDate = utils.setYear(date, year);
    if (onYearChange) onYearChange(newDate);
    if (onChange) onChange(newDate, true);
  }, [date, onChange, onYearChange, utils]);
  return /*#__PURE__*/React.createElement(YearViewContainer, other, utils.getYearRange(minDate, maxDate).map(function (year) {
    var yearNumber = utils.getYear(year);
    var selected = yearNumber === currentYear;
    return /*#__PURE__*/React.createElement(Year, {
      key: utils.getYearText(year),
      selected: selected,
      value: yearNumber,
      onSelect: onYearSelect,
      ref: selected ? selectedYearRef : undefined,
      disabled: Boolean(disablePast && utils.isBeforeYear(year, utils.date()) || disableFuture && utils.isAfterYear(year, utils.date()))
    }, utils.getYearText(year));
  }));
};
YearView.protoTypes = {
  animateYearScrolling: PropTypes.bool,
  date: PropTypes.instanceOf(Date).isRequired,
  disablePast: PropTypes.bool,
  disableFuture: PropTypes.bool,
  onChange: PropTypes.func,
  onYearChange: PropTypes.func,
  minDate: PropTypes.instanceOf(Date).isRequired,
  maxDate: PropTypes.instanceOf(Date).isRequired
};
YearView.defaultProps = {
  animateYearScrolling: true,
  disablePast: false,
  disableFuture: false
};
export default YearView;